import holidayResource from '../resource';

export function getHolidays(year) {
  return holidayResource.getHolidays(year).then(response => response.data);
}

export function deleteHoliday(id) {
  return holidayResource.deleteHoliday(id);
}
export function create(holiday) {
  return holidayResource.create(holiday);
}
